<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Parecer de Conformidade -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label class="required">Justificativa</label>
                    <b-input-group>
                        <b-form-textarea
                            type="text"
                            v-model="justificativa"
                            placeholder="Justificativa"
                            :rows="10"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>Justificativa é Obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        pleito: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations: {
        justificativa: {
            required
        },
    },

    data() {
        return {
            justificativa: null,
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'A') {
                return 'APROVAÇÃO'
            }
            return 'REPROVAÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.justificativa = null
        },

        salvar() {
            let conformidadeTecnicaDto = {
                pleitoId : this.pleito.pleitoId,
                justificativa: this.justificativa
            }
            this.$emit('salvar', conformidadeTecnicaDto)
            this.fecharModal()
        },
    },
}
</script>
